import { ApiHttpService } from '../../services';

export const OpenPurchaseOrderModule = {
    namespaced: true,
    actions: {
        async listPurchaseOrders(context, payload) {
            const response = await ApiHttpService.getRequest('open-purchase-orders', payload);
            return response.data;
        },
        async listPurchaseOrderLines(context, payload) {
            const response = await ApiHttpService.getRequest('open-purchase-order-lines', payload);
            return response.data;
        },
        async getPurchaseOrder(context, { docEntry, connection }) {
            const response = await ApiHttpService.getRequest('open-purchase-orders/' + encodeURIComponent(docEntry), { connection });
            return response.data;
        }
    }
};
